import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import coinImg from '../../img/hero/hero1-coin.png'
import coinImg2 from "../../img/others/cta1-mian-img.png"
import cta1 from "../../img/bg/cta1-shape-bg.png"
import cta2 from "../../img/shapes/blog-shape.png"
import authorImg from "../../img/icons/author.png"
import dateImg from "../../img/icons/date.png"
import blogImg from "../../img/blog/blog1-image3.png"
import blogImg5 from "../../img/blog/blog1-image2.png"
import blogImg6 from "../../img/blog/blog1-image1.png"
import mapimg from "../../img/testimonial/map.png"
import mapimg1 from "../../img/testimonial/tes1-img1.png"
import mapimg2 from "../../img/testimonial/tes1-img2.png"
import mapimg3 from "../../img/testimonial/tes1-img3.png"
import mapimg4 from "../../img/testimonial/tes1-img4.png"
import mapimg5 from "../../img/testimonial/tes1-img5.png"
import mapimg6 from "../../img/testimonial/tes1-img6.png"
import iconImg2 from "../../img/icons/tes1-icon.png"
import bankicon1 from "../../img/icons/bank1.svg"
import bankicon2 from "../../img/icons/bank2.svg"
import bankicon3 from "../../img/icons/bank3.svg"
import heromob from "../../img/hero/hero1-mobile1.png"
import heromob1 from "../../img/hero/hero1-mobile2.png"
import heromob2 from "../../img/hero/hero1-mobile3.png"
import heromain from "../../img/hero/hero1-main.png"
import app1 from "../../img/hero/app1.png"
import app2 from "../../img/hero/app2.png"
import appqr from "../../img/hero/qr.png"
import appARROW from "../../img/shapes/arrow.png"
import about1 from "../../img/bg/about1-shape-bg.png"
import about2 from "../../img/shapes/about1-shape.png"
import about3 from "../../img/about/about1-img1.png"
import about4 from "../../img/about/about1-img2.png"
import about5 from "../../img/about/about1-img3.png"
import abouticon1 from "../../img/icons/about1-icon1.svg"
import abouticon2 from "../../img/icons/about1-icon2.svg"
import fact from "../../img/icons/fact-icon1.svg"
import fact2 from "../../img/icons/fact-icon2.svg"
import fact3 from "../../img/icons/fact-icon3.svg"
import footerimg from "../../img/shapes/footer-shape2.png"
import footer5 from "../../img/shapes/footer-shape5.png"
import footer4 from "../../img/shapes/footer-shape4.png"
import footer1 from "../../img/shapes/footer-shape1.png"
import marketing from "../../img/logo/marketing-logo1.png"
import marketing2 from "../../img/logo/marketing-logo2.png"
import marketing3 from "../../img/logo/marketing-logo3.png"
import marketing4 from "../../img/logo/marketing-logo4.png"
import marketing5 from "../../img/logo/marketing-logo5.png"
import marketing6 from "../../img/logo/marketing-logo6.png"
import service from "../../img/icons/service1-icon1.svg"
import service1 from "../../img/icons/service1-icon2.svg"
import service2 from "../../img/service/service1-main-img.png"
import service3 from "../../img/service/service1-img-shape1.png"
import service4 from "../../img/service/service1-img-shape2.png"
import service5 from "../../img/shapes/service1-shape1.png"
import service6 from "../../img/shapes/service1-shape2.png"
import service7 from "../../img/shapes/service1-shape3.png"
import service8 from "../../img/shapes/service1-shape4.png"
import service9 from "../../img/icons/service1-icon3.svg"
import service10 from "../../img/icons/service1-icon4.svg"
import work from "../../img/work/work1-img1.png"
import work1 from "../../img/work/work1-img2.png"
import work2 from "../../img/work/work1-img3.png"
import appleicon from "../../img/others/apple-btn.png"
import gglicon from "../../img/others/goole-btn.png"
import mobbg from "../../img/bg/mobile-image-bg.png"
import mobarea from "../../img/others/mobile-area-img.png"
import mobareacoin from "../../img/others/mobile-area-coin.png"
import mobqr from "../../img/others/mobile-area-qr.png"
import mobshape from "../../img/shapes/mobile-area-shape.png"
import aboutpaycoin from "../../img/about/common-hero-coin.png"
import aboutpaycoin2 from "../../img/about/about-hero-area.png"
import marketicon from "../../img/icons/market-icon1.png"
import marketicon1 from "../../img/icons/market-i.png"
import marketicon2 from "../../img/icons/market-icon2.png"
import marketicon3 from "../../img/icons/market-icon3.png"
import marketicon4 from "../../img/icons/market-icon4.png"
import marketchart from "../../img/icons/market-chart1.png"
import marketchart1 from "../../img/icons/market-chart2.png"
import marketchart2 from "../../img/icons/market-chart3.png"
import coppyicon from "../../img/icons/coppy-icon.png"
import greencheck from "../../img/icons/green-check.png"
import buypayicon from "../../img/icons/buy-pay-icon3.png"
import buypayicon1 from "../../img/icons/buy-pay-icon2.png"
import buypayicon2 from "../../img/icons/buy-pay-icon1.png"
import exchangeimg from "../../img/icons/exchnage-icon.png"

import { faStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';



SwiperCore.use([Navigation, Autoplay]);

const BuyCrypto = () => {

    useEffect(() => {
        AOS.init({
            duration: 800,  // You can set the duration here or directly in the HTML as data-aos-duration
        });
    }, []);

    const navigate = useNavigate()
    return (
        <>
            <Header />
            <div class="common-hero" style={{ backgroundImage: `url(${require('../../img/bg/common-hero-bg.png')})` }}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="main-heading">
                                <h1>Buy Crypto-coin</h1>
                                <div class="space16"></div>
                                <p>Investing in cryptocurrenciesan be exciting journey, but it's essential to approach it with caution and diligence.</p>
                                <div class="subscribe-form">
                                    <form action="#">
                                        <input type="email" placeholder="Email Address" />
                                        <div class="button">
                                            <button class="theme-btn1 btn btn--ripple ripple">Get Started <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="common-hero-images">
                                <div class="image1">
                                    <img src={aboutpaycoin} alt="" />
                                </div>

                                <div class="image2">
                                    <img src={aboutpaycoin2} alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buy-area sp">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 m-auto text-center">
                            <div class="heading1">
                                <span class="span">three step follow</span>
                                <h2>buy crypto step to step</h2>
                            </div>
                        </div>
                    </div>

                    <div class="space30"></div>
                    <div class="row">
                        <div class="col-lg-1">

                        </div>
                        <div class="col-lg-3">
                            <div class="buy-sell-box">
                                <ul>
                                    <li><a href="/buyCrypto"  class="active">Buy crypto</a></li>
                                    <li class="space16"></li>
                                    <li><a href="/sellBuyCrypto">Sell Crypto</a></li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-lg-7">

                            <div class="form-all-buy">

                                <div class="progress-bar">
                                    <div class="step-indicator selected">
                                        <span class="dot" id="dot-1"></span>
                                        <span class="label"> Select Currency</span>
                                    </div>
                                    <div class="step-indicator">
                                        <span class="dot" id="dot-2"></span>
                                        <span class="label"> Important Notes</span>
                                    </div>
                                    <div class="step-indicator">
                                        <span class="dot" id="dot-3"></span>
                                        <span class="label"> Payment Details</span>
                                    </div>
                                </div>
                                <form id="multiStepForm">
                                    <div class="step step-1 active">
                                        <div class="stap-form-bg">
                                            <div class="heading">
                                                <h4>Select Currency</h4>
                                                <div class="space16"></div>
                                                <p>Reference Price: 1,450,939,280.43 VND/BTC</p>
                                            </div>
                                            <div class="space10"></div>
                                            <div class="row align-items-center">
                                                <div class="col-md-5">
                                                    <div class="single-input">
                                                        <label>Pay</label>
                                                        <input type="text" placeholder="US$ Dollar" />
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="icon">
                                                        <img src={exchangeimg} alt="" />
                                                    </div>
                                                </div>

                                                <div class="col-md-5">
                                                    <div class="single-input">
                                                        <label>Receive</label>
                                                        <input type="text" placeholder="BTC" />
                                                    </div>
                                                </div>

                                                <div class="space30"></div>
                                                <div class="col-lg-12">
                                                    <div class="button text-end">
                                                        <button class="theme-btn1 next-btn btn btn--ripple ripple">Get A Quote <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="step step-2">
                                        <div class="stap-form-bg">
                                            <div class="heading">
                                                <h4>Confirm Information</h4>
                                                <div class="space16"></div>
                                                <p>You Are About To Receive 1.356 BTC For Bit cloud Bank</p>
                                            </div>
                                            <div class="space40"></div>
                                            <div class="row align-items-center">
                                                <div class="col-md-4">
                                                    <div class="pay-box">
                                                        <div class="pay-icon">
                                                            <img src={buypayicon2} alt="" />
                                                        </div>
                                                        <div class="heading">
                                                            <h6>Pay</h6>
                                                            <p>3.000 VND</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="pay-box">
                                                        <div class="pay-icon">
                                                            <img src={buypayicon1} alt="" />
                                                        </div>
                                                        <div class="heading">
                                                            <h6>Get</h6>
                                                            <p>0.3232 BTC</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="pay-box">
                                                        <div class="pay-icon">
                                                            <img src={buypayicon} alt="" />
                                                        </div>
                                                        <div class="heading">
                                                            <h6>For</h6>
                                                            <p>PayCoin</p>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="stap-form-bg">
                                            <div class="heading">
                                                <h4>Payment Details</h4>
                                                <div class="space24"></div>
                                                <h3>Bank Account</h3>
                                            </div>
                                            <div class="row">
                                                <div class="single-input input2">
                                                    <label>Account Name</label>
                                                    <input type="text" placeholder="Jofra Archer" />
                                                </div>

                                                <div class="single-input input2">
                                                    <label>Account Number</label>
                                                    <input type="number" placeholder="V548422222221" />
                                                </div>

                                                <div class="single-input input2">
                                                    <label>Address</label>
                                                    <input type="text" placeholder="079 Dariana Knoll, CA" />
                                                </div>

                                                <div class="single-input input2">
                                                    <label>SWIFT Code</label>
                                                    <input type="text" placeholder="UI8" />
                                                </div>

                                                <div class="single-input input2">
                                                    <label>Bank Address</label>
                                                    <input type="text" placeholder="55416 Powlowski Spring, CA" />
                                                </div>

                                                <div class="space24"></div>
                                                <h3>Reference code</h3>
                                                <div class="space16"></div>
                                                <p>the Reference Code in your deposit in order to credit your account!</p>
                                                <div class="space24"></div>
                                                <div class="copy">
                                                    <p>BLUTUKHY34PB</p>
                                                </div>

                                                <div class="Cancel-btn">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="button1">
                                                                <button class="theme-btn1 prev-btn prev-btn btn btn--ripple ripple" type="button">Cancel</button>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="button2">
                                                                <button class="theme-btn1 next-btn btn btn--ripple ripple" type="button">Get Started</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="step step-3">
                                        <div class="stap-form-bg">
                                            <div class="sucsess-area heading">
                                                <h5>Success <img src={greencheck} alt="" /></h5>
                                                <div class="space16"></div>
                                                <p class="per">You successfully bought 1.356<a href="#" class="btc"> BTC</a> for PayCoin!</p>

                                                <div class="completed-box">
                                                    <div class="row-box">
                                                        <p>Status</p>
                                                        <p class="color">Completed</p>
                                                    </div>

                                                    <div class="completed-border"></div>
                                                    <div class="row-box">
                                                        <p>Transaction ID</p>
                                                        <p>0msx836930...87r398 ID</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="stap-form-bg">
                                            <div class="sucsess-area heading">
                                                <h4>Payment Details</h4>
                                                <div class="completed-box new">
                                                    <div class="row-box">
                                                        <p>Account Name</p>
                                                        <p>Jofra Archer <img src={coppyicon} alt="" /></p>
                                                    </div>

                                                    <div class="completed-border"></div>
                                                    <div class="row-box">
                                                        <p>Account Number</p>
                                                        <p>V548422222221 <img src={coppyicon} alt="" /></p>
                                                    </div>

                                                    <div class="completed-border"></div>
                                                    <div class="row-box">
                                                        <p>Address</p>
                                                        <p>079 Dariana Knoll, CA <img src={coppyicon} alt="" /></p>
                                                    </div>

                                                    <div class="completed-border"></div>
                                                    <div class="row-box">
                                                        <p>SWIFT Code</p>
                                                        <p>UI8 <img src={coppyicon} alt="" /></p>
                                                    </div>

                                                    <div class="completed-border"></div>
                                                    <div class="row-box">
                                                        <p>Bank Address</p>
                                                        <p>55416 Powlowski Spring, CA <img src={coppyicon} alt="" /></p>
                                                    </div>

                                                    <div class="completed-border"></div>

                                                    <div class="space24"></div>
                                                    <h3>Reference code</h3>
                                                    <div class="space16"></div>
                                                    <p>the Reference Code in your deposit in order to credit your account!</p>
                                                    <div class="space24"></div>
                                                    <div class="copy">
                                                        <p id="copyButton">BLUTUKHY34PB</p>
                                                    </div>

                                                    <div class="Cancel-btn">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <div class="button1">
                                                                    <button class="theme-btn1 prev-btn prev-btn btn btn--ripple ripple" type="button">Trade</button>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div class="button2">
                                                                    <button class="theme-btn1 next-btn btn btn--ripple ripple" type="submit">Wallet</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </form>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default BuyCrypto